import type { CustomPost2 } from '~/types'

export const useNewsArticleSchema = ({
  post,
  source,
}: {
  post: MaybeRef<CustomPost2 | undefined>
  source?: MaybeRef<boolean>
}) => {
  if (unref(source)) {
    return {}
  }

  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const { baseUrl } = runtimeConfig.public

  return computed(() => {
    const rawPost = unref(post)
    return {
      type: 'application/ld+json',
      json: {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': baseUrl + route.path,
        },
        headline: rawPost?.title_seo,
        image: rawPost?.image_og?.url ? [rawPost?.image_og.url] : undefined,
        datePublished: rawPost?.created_at,
        dateModified: rawPost?.created_at,
        author: {
          '@type': 'Person',
          name: rawPost?.user?.nickname,
          url: `${baseUrl}/wapers/${rawPost?.user?.slug}`,
        },
        publisher: {
          '@id': `${baseUrl}/#organization`,
        },
        inLanguage: 'fr-FR',
        commentCount: rawPost?.comments_count,
        potentialAction: [
          {
            '@type': 'CommentAction',
            name: 'Comment',
            target: [`${baseUrl + route.path}/#comment`],
          },
        ],
      },
    }
  })
}
